export const endPoints = {
  DUPLICATE_CONTROL: '/v1/duplicate-control/config'
};
